import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CardElementsBaseComponent } from '../card-elements-base.component';

@Component({
  selector: 'cu-dynamic-card-footer',
  templateUrl: './card-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardFooterComponent extends CardElementsBaseComponent {
  constructor() {
    super();
  }
}
